<router-outlet />
<app-toaster />
<app-loader></app-loader>
<app-confirm-remove></app-confirm-remove>
<app-confirmation-box></app-confirmation-box>
<app-alert-info></app-alert-info>